import { BsThreeDots } from "react-icons/bs";
import { IconBaseProps } from "react-icons";

interface MoreOptionsIconProps extends IconBaseProps {
  className?: string;
}

export default function MoreOptionsIcon({ className = "", size = 24, ...props }: MoreOptionsIconProps) {
  return <BsThreeDots className={className} size={size} {...props} />;
}
